import React, { useState, useRef, useEffect } from 'react';
import Headline from 'headline';
import stickerData from 'data/sticker.json';
import Img from 'img';
import Icon from 'icon';
import { qualityColor } from 'utils/helpers';
import { navigate } from 'gatsby';
import s from './infl-sticker.module.scss';

export default function InfluencersSticker(props) {
  const [dragging, setDragging] = useState(false);
  const sticker = useRef(null);
  const [randomizedData, setRandomizedData] = useState(null);
  const { white } = props;
  const whiteClass = white ? s.white : '';

  useEffect(() => {
    setRandomizedData([
      ...stickerData
        .filter(
          ({
            firstName,
            lastName,
            username,
            qualityScore,
            country,
            featuredImage
          }) =>
            firstName &&
            lastName &&
            username &&
            qualityScore &&
            country &&
            featuredImage
        )
        .sort(() => 0.5 - Math.random())
        .slice(0, 30)
    ]);
  }, []);

  const handleArrowNext = () => {
    if (dragging) return;
    setDragging(true);
    const end = sticker.current.scrollLeft + window.innerWidth - 100;
    const scrollInterval = setInterval(() => {
      if (sticker.current.scrollLeft < end) {
        const prevScroll = [sticker.current.scrollLeft]; // shallow copy
        sticker.current.scrollLeft += 25;
        if (sticker.current.scrollLeft === prevScroll[0]) {
          clearInterval(scrollInterval);
          setDragging(false);
          }
      } else {
        clearInterval(scrollInterval);
        setDragging(false);
      }
    }, 1);
  };
  const handleArrowPrev = () => {
    if (dragging) return;
    setDragging(true);
    const end = sticker.current.scrollLeft - window.innerWidth - 100;
    const scrollInterval = setInterval(() => {
      if (sticker.current.scrollLeft > end && sticker.current.scrollLeft > 0) {
        sticker.current.scrollLeft -= 25;
      } else {
        clearInterval(scrollInterval);
        setDragging(false);
      }
    }, 1);
  };

  return (
    <section
      className={`${s.root} ${whiteClass}`}
      // onMouseDown={e => handleMouseDown(e)}
      // onMouseMove={e => handleMouseMove(e)}
      draggable={false}
    >
      <div
        className={`${s.arrowWrapper} ${s.prev}`}
        onClick={() => handleArrowPrev()}
      >
        <Icon icon="chevron-left" />
      </div>
      <div
        className={`${s.arrowWrapper} ${s.next}`}
        onClick={() => handleArrowNext()}
      >
        <Icon icon="chevron-right" />
      </div>
      <div className={s.wrapper} ref={sticker}>
        <div className={s.listWrapper}>
          <ul draggable={false} className={`${s.list}`}>
            {randomizedData?.map(
              ({
                firstName,
                lastName,
                username,
                qualityScore,
                country,
                featuredImage
              }) => {
                return (
                  <li
                    draggable={false}
                    key={username}
                    className={s.card}
                    onClick={() =>
                      navigate(`/influencers/${username.replace('@', '')}`)
                    }
                  >
                    <div className={s.imgWrapper}>
                      <Img
                        draggable={false}
                        className={s.image}
                        src={featuredImage?.id}
                        alt={featuredImage?.id}
                      />
                    </div>

                    <div className={s.infoWrapper} draggable={false}>
                      <Headline
                        draggable={false}
                        className={s.title}
                        h6="true"
                        secondary
                        el="a"
                        href={`/influencers/${username.replace('@', '')}`}
                      >
                        {`${firstName.split('/')[0]} ${lastName.split('/')[0]}`}
                      </Headline>
                      <div className={s.item} draggable={false}>
                        <Icon icon="link" />
@
                        {username}
                      </div>
                      <div className={s.item} draggable={false}>
                        <Icon icon="location-small" />
                        {country?.name}
                      </div>
                    </div>
                    <div
                      className={`${s.quality} ${
                        s[qualityColor(qualityScore)]
                      }`}
                      draggable={false}
                    >
                      {qualityScore}
                      <span>of 100</span>
                    </div>
                  </li>
                );
              }
            )}
          </ul>
        </div>
      </div>
    </section>
  );
}
